import axios from 'axios';
import { ElMessage } from 'element-plus';
const baseURL = process.env.VUE_APP_BASE_URL;
//const baseURL = 'http://192.168.2.31:8109'; //本地调试地址

const service= axios.create({
  baseURL: baseURL,
  timeout: 50000
});
service.interceptors.response.use(
  response => {
    if (response?.data?.code === 200) {
      // 如果接口返回code为200，或者用户配置了自定义处理错误，则直接返回数据
      return response.data;
    } else {
      //统一处理错误
      showError(response.data || response, response.config);
      return Promise.reject(response.data || response);
    }
  },
  error => {
    const badMessage= error.message || error
    showError({ message: badMessage });
    return Promise.reject(error);
  }
);

// 错误处理
function showError(error) {
  ElMessage({
    message:   error.msg || error.message || '服务异常',
    type: 'error',
    duration: 3 * 1000,
  });
}
export default service;
